<template>
  <div
    class="flex w-full items-center justify-around rounded-b-lg border-0 border-t border-solid py-3 border-gray">

    <base-tooltip-button :variant="formatting.bold ? 'rich-input-active' : 'rich-input'"
                         tooltip-text="Bold"
                         @click="$emit('apply-format', { prop: 'bold' })"
    >
      <bold-icon class="h-5 w-5"/>
    </base-tooltip-button>

    <base-tooltip-button :variant="formatting.italic ? 'rich-input-active' : 'rich-input'"
                         tooltip-text="Italic"
                         @click="$emit('apply-format', { prop: 'italic' })"
    >
      <italic-icon class="h-5 w-5"/>
    </base-tooltip-button>

    <rich-input-toolbar-dropdown :options="listOptions"
                                 @apply-format="$emit('apply-format', { prop: 'list', val: $event })"
    />

    <rich-input-toolbar-dropdown :options="alignOptions"
                                 @apply-format="$emit('apply-format', { prop: 'align', val: $event })"
    />

    <rich-input-link :cursor-position="cursorPosition"
                     :text-editor-id="textEditorId"
                     :trigger-tooltip="!!formatting.link ? 'Edit link' : 'Insert link'"
                     :formatting="formatting"
                     :get-selected-text-editor="getSelectedTextEditor"
                     @insert-link="$emit('insert-link', $event)"
                     @remove-link="$emit('remove-link', $event)"
                     @edit-link="$emit('edit-link', $event)"
    />

    <rich-input-emojis @insert-emoji="$emit('insert-emoji', $event)"/>

  </div>
</template>

<script>
import BaseButton from '@/components/base-components/BaseButton.vue'
import RichInputToolbarDropdown from '@/components/base-components/rich-input/RichInputToolbarDropdown.vue'
import RichInputEmojis from '@/components/base-components/rich-input/RichInputEmojis.vue'
import RichInputLink from '@/components/base-components/rich-input/RichInputLink.vue'
import BaseTooltipButton from '@/components/base-components/BaseTooltipButton.vue'
import BoldIcon from '@/assets/images/icons/BoldIcon.vue'
import ItalicIcon from '@/assets/images/icons/ItalicIcon.vue'

export default {
  name: 'RichInputToolbar',

  components: {
    BaseTooltipButton,
    RichInputLink,
    RichInputEmojis,
    BaseButton,
    RichInputToolbarDropdown,
    BoldIcon,
    ItalicIcon
  },

  props: {
    formatting: {
      type: Object,
      default: () => {}
    },
    cursorPosition: {
      type: Object,
      default: () => {}
    },
    textEditorId: {
      type: String,
      default: ''
    },
    getSelectedTextEditor: {
      type: Function,
      default: () => (() => '')
    }
  },

  data() {
    return {
      listOptions: [
        { value: 'bullet', icon: 'bullets-icon', tooltip: 'Bulleted list' },
        { value: 'ordered', icon: 'order-icon', tooltip: 'Numbered list' }
      ],
      alignOptions: [
        { value: 'left', icon: 'align-left-icon', tooltip: 'Align left' },
        { value: 'center', icon: 'align-center-icon', tooltip: 'Align center' },
        { value: 'right', icon: 'align-right-icon', tooltip: 'Align right' },
        { value: 'justify', icon: 'align-justify-icon', tooltip: 'Justify' }
      ]
    }
  }
}
</script>

<style lang="scss">
.rich-input-dropdown {
  bottom: 34px;
  left: 0;
}

.rich-input-dropdown-emoji {
  bottom: 31px;
  right: -4px;
}
</style>

